import styled from 'styled-components';

const shouldForwardProp = prop => !['isOpen'].includes(prop);

export const EvidenceDocumentsStyled = styled.div.withConfig({ shouldForwardProp })`
  display: flex;
  flex-direction: column;
  gap: 20px;

  .cardContainer {
    display: flex;
    gap: 10px;
    flex-direction: column;
    border-top: 1px solid var(--GrayScale-400);
    background: var(--GrayScale-0);
    padding: 16px;
  }

  .modalTitleWrapper {
    position: sticky;
    width: 100%;
    left: 0;
    top: 0;
    padding: 16px;
    border-bottom: 1px solid #dddd;
    background: var(--GrayScale-0);
    border-radius: 16px 16px 0 0;
  }

  .modalContentWrapper {
    padding: 16px 24px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
`;
